/** @format */
import { useDispatch, useSelector } from 'react-redux';
import { BlockActions, BlockReducerType } from '../../block/blockReducers';
import { useEffect } from 'react';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { MvnoBlockListCollectionInterface } from '../../../interfaces/collections/MvnoBlockListCollectionInterface';
import Filter from '../../../interfaces/forms/Filter';

export const useBlockList = (platformResellerId?: number | null): MvnoBlockListCollectionInterface | null => {
    const dispatch = useDispatch();
    const { blockListCollections } = useSelector((state: { blockReducers: BlockReducerType }) => state.blockReducers);

    let filters: Array<Filter> = [
        { name: 'deleted', value: false },
        { name: 'pagination', value: false },
    ];
    if (platformResellerId) {
        filters = [...filters, { name: 'platformResellerId', value: platformResellerId }];
    }

    useEffect(() => {
        if (!blockListCollections) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
                BlockActions.BLOCK_LIST_LOAD,
                filters,
                [{ name: 'blockName', value: 'asc' }],
                (data: MvnoBlockListCollectionInterface): void => {
                    dispatch({
                        type: BlockActions.BLOCK_LIST_LOAD,
                        blockListCollections: data,
                    });
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [blockListCollections, dispatch, platformResellerId, filters]);

    return blockListCollections ?? null;
};
